// Centralização de textos e estilos para telas de onboarding (create-user, create-pin, confirm-pin, concluded)
// Evita repetição de strings e classes utilitárias Tailwind.

// Textos
export const onboardingText = {
  createUser: {
    title: 'Crea tu cuenta',
    switchToLogin: '¿Ya tienes una cuenta?',
    loginCta: 'Inicia sesión',
    submit: 'Registrarse',
    formHint: 'Complete todos los campos válidamente para continuar.',
  },
  createPin: {
    header: 'Creación PIN',
    instruction: 'Ingrese 4 dígitos numéricos',
    footnote:
      '*Este PIN será su contraseña asociada a su usario para ingresar a esta aplicación',
    cta: 'Continuar',
    invalidSame: 'El PIN no puede tener todos los dígitos iguales.',
    invalidSequential: 'El PIN no puede ser una secuencia (ej: 1234 o 4321).',
    invalidPattern:
      'El PIN no puede ser una secuencia en el teclado (ej: 2580).',
    invalidCommon: 'El PIN no puede ser un patrón común (ej: 1212, 6969).',
  },
  confirmPin: {
    header: 'Confirmar PIN',
    instruction: 'Confirme PIN',
    footnote:
      '*Confirme su PIN, debe ser el mismo que ingresó en la anterior pantalla',
    cta: 'Crear PIN',
    mismatch: 'El PIN no coincide. Intenta nuevamente.',
    missingData: 'Faltan datos de usuario. Reinicie el proceso.',
    errorCreate: 'Error al crear el PIN. Intente más tarde.',
  },
  concluded: {
    success: '¡Te registraste con éxito!',
    cta: 'Continuar',
  },
}

// Classes Tailwind reutilizáveis
export const onboardingStyles = {
  headerBar:
    'bg-primary-darkest flex h-[66px] w-full items-center justify-center',
  headerTitle: 'text-[24px] font-inter text-white',
  pageWrapper: 'flex w-full flex-col items-center gap-12 px-8',
  section: 'flex w-full flex-col gap-2 pt-10',
  instruction: 'pb-6 text-lg font-normal text-center',
  pinWrapper: 'flex justify-center',
  footnote:
    'flex w-full flex-col items-center pt-34 p-7 text-sm text-[#736969]',
  actionContainer: 'flex w-full flex-col items-center pt-0',
  primaryButton:
    '!bg-primary-darkest h-[55px] w-full rounded-[10px] text-xl font-semibold',
  // Create User specifics
  createUserOuter:
    'flex w-full flex-col items-center gap-8 px-6 sm:gap-12 sm:px-8',
  createUserHeader: 'flex w-full flex-col gap-1 pt-6 sm:pt-8',
  createUserTitle: 'pb-3 text-center text-base font-normal sm:pb-6 sm:text-lg',
  createUserInputsGap: 'flex flex-col gap-5 sm:gap-8',
  createUserButton:
    'h-[55px] w-full rounded-[10px] text-lg font-semibold sm:h-[55px] sm:text-xl',
  createUserHint:
    'mt-2 w-full text-center text-[11px] text-gray-500 sm:mt-3 sm:text-xs',
  createUserSwitchBlock: 'pt-4 pb-4 sm:py-8',
  concludedWrapper:
    'flex min-h-screen w-full flex-col items-center justify-center px-8',
  concludedInner: 'flex flex-col items-center',
  concludedButton:
    'h-[55px] w-full max-w-[196px] rounded-[10px] text-xl font-semibold mt-4',
  createPinError: 'mt-4 text-sm text-red-600 text-center px-4',
}

export type OnboardingTextKey = typeof onboardingText
export type OnboardingStylesKey = typeof onboardingStyles

// Aliases para compatibilidade com código existente que usa nomes em maiúsculas
export const ONBOARDING_TEXT = onboardingText
export const ONBOARDING_STYLES = onboardingStyles
